'use strict';

var ACC;
ACC.myaccount = {
    map: '',
    _autoload: ['accountPageValidation', 'accountChangePassword', 'accountSelectBox'],

    bindAll: function() {
        this.bindSubmitButtons();
        this.appendErrorIcons();

        $('.address-details-signout a').on('click', function() {
            ACC.checkoutsteps.clearSelectedStore();
        });
        $('.account-section select').accessibleSelectric();
    },

    appendErrorIcons: function() {
        var $profileFormFields = $('#tjxUpdateProfileForm').find('.form-group');

        if ($profileFormFields.length) {
            $profileFormFields.each(function(i, formField) {
                var $formField = $(formField);

                if ($formField.hasClass('has-error')) {
                    $formField.prepend('<i class="icon icon-cancel-circled error"></i>');
                }
            });
        }
    },

    bindSubmitButtons: function() {
        var $profileForm = $('#tjxUpdateProfileForm');

        $('[data-update-details]').on('click', function(e) {
            e.preventDefault();
            $profileForm.attr('action', '/my-account/update-profile').submit();
        });

        $('[data-update-email]').on('click', function(e) {
            e.preventDefault();
            $profileForm.attr('action', '/my-account/update-email').submit();
        });

        $('[data-update-password]').on('click', function(e) {
            e.preventDefault();
            $profileForm.attr('action', '/my-account/update-password').submit();
        });
    },

    accountPageValidation: function() {
        $('#profile-title')
            .blur(function() {
                var $parentClass = $(this).closest('.form-group');

                if ($(this).val() === null) {
                    if ($parentClass.find('i').length > 0) {
                        $parentClass.find('i').remove();
                    }

                    var divStr =
                        '<div class="help-block"><span>' +
                        $('#selectMessage').val() +
                        '</span></div>';

                    $(this)
                        .closest('.form-select')
                        .prepend('<i class="icon icon-cancel-circled error"></i>');

                    if ($parentClass.find('div.help-block').length === 1) {
                        $parentClass.find('div.help-block span').html($('#selectMessage').val());
                        $parentClass.addClass('has-error');
                    } else {
                        $parentClass.append(divStr);
                        $parentClass.addClass('has-error');
                    }
                }
            });

        $('#profile-title').change(function() {
            var $parentClass = $(this).closest('.form-group');

            if ($(this).val !== '') {
                if ($parentClass.find('i').length > 0) {
                    $parentClass.find('i').remove();
                }

                if ($parentClass.find('div.help-block').length === 1) {
                    $parentClass.find('div.help-block span').html('');
                    $parentClass.removeClass('has-error');

                    $(this)
                        .closest('.form-select')
                        .prepend('<i class="tick icon icon-check-circle"></i>');
                } else {
                    $(this)
                        .closest('.form-select')
                        .prepend('<i class="tick icon icon-check-circle"></i>');
                }
            }
        });

        $('#profile-pwd, #currentPassword').blur(function() {
            var $thisVal = $(this),
                txtValue = $.trim($thisVal.val()),
                $parentClass = $thisVal.closest('.form-group'),
                inputType = $thisVal.data('type'),
                errorMsg = $thisVal.data('error'),
                divStr = '<div class="help-block"><span>' + errorMsg + '</span></div>';

            if (inputType === 'validate') {
                if (txtValue !== '') {
                    if ($parentClass.find('i').length > 0) {
                        $parentClass.find('i').remove();
                    }

                    $parentClass.prepend('<i class="tick icon icon-check-circle"></i>');
                    $parentClass.removeClass('has-error');

                    if ($parentClass.find('div.help-block').length === 1) {
                        $parentClass.find('div.help-block span').html('');
                    }
                } else {
                    if ($parentClass.find('i').length > 0) {
                        $parentClass.find('i').remove();
                    }
                    $parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');
                    $parentClass.addClass('has-error');

                    if ($parentClass.find('div.help-block').length === 1) {
                        $parentClass.find('div.help-block span').html(errorMsg);
                    } else {
                        $parentClass.append(divStr);
                    }
                }
            }
        });

        $('#profile-email').blur(function() {
            var $obj = $(this),
                $parentClass = $obj.closest('.form-group'),
                emailId = $.trim($obj.val()),
                errorMsg;

            if (emailId === '') {
                errorMsg = $obj.data('error');
            } else {
                errorMsg = $obj.data('validemail');
            }

            var email = $obj.val(),
                divStr = '<div class="help-block"><span>' + errorMsg + '</span></div>',
                emailProperty = $('#emailRegex').text().trim(),
                regex = new RegExp(emailProperty);

            if (regex.test(email)) {
                if ($parentClass.find('i').length > 0) {
                    $parentClass.find('i').remove();
                }
                if ($parentClass.find('div.help-block').length === 1) {
                    $parentClass.find('div.help-block span').html('');
                }

                $parentClass.removeClass('has-error');
                $parentClass.prepend('<i class="tick icon icon-check-circle"></i>');
            } else {
                if ($parentClass.find('i').length > 0) {
                    $parentClass.find('i').remove();
                }
                if ($parentClass.find('div.help-block').length === 1) {
                    $parentClass.find('div.help-block span').html(errorMsg);
                } else {
                    $parentClass.append(divStr);
                }

                $parentClass.addClass('has-error');
                $parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');
            }
        });

        $('#newPassword').blur(function() {
            ACC.validation.passwordInput($(this));
        });

        $('#checkNewPassword').blur(function() {
            var $parentClass = $(this).closest('.form-group'),
                confirmPasswordValue = $.trim($(this).val()),
                passwordValue = $.trim($('#newPassword').val()),
                errorMsg;

            if (confirmPasswordValue === '') {
                errorMsg = $(this).data('nullerror');
            } else {
                errorMsg = $(this).data('error');
            }

            var divStr = '<div class="help-block"><span>' + errorMsg + '</span></div>';

            if (passwordValue !== confirmPasswordValue && passwordValue !== '') {
                if ($parentClass.find('i').length > 0) {
                    $parentClass.find('i').remove();
                }

                $parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');

                if ($parentClass.find('div.help-block').length === 1) {
                    $parentClass.find('div.help-block span').html(errorMsg);
                    $parentClass.addClass('has-error');
                } else {
                    $parentClass.append(divStr);
                    $parentClass.addClass('has-error');
                }
            } else {
                if (passwordValue.length > 0) {
                    if ($parentClass.find('i').length > 0) {
                        $parentClass.find('i').remove();
                    }
                    $parentClass.removeClass('has-error');
                    $parentClass.find('div.help-block span').html('');
                    $parentClass.prepend('<i class="tick icon icon-check-circle"></i>');
                }

                if (confirmPasswordValue === '') {
                    if ($parentClass.find('i').length > 0) {
                        $parentClass.find('i').remove();
                    }

                    $parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');

                    if ($parentClass.find('div.help-block').length === 1) {
                        $parentClass.find('div.help-block span').html(errorMsg);
                        $parentClass.addClass('has-error');
                    } else {
                        $parentClass.append(divStr);
                        $parentClass.addClass('has-error');
                    }
                }
            }
        });
    },

    accountChangePassword: function() {
        $('#newPassword').focus(function() {
            if ($('.pw-form-messaging').is(':visible') !== true) {
                $(this)
                    .closest('.form-group')
                    .append(
                        '<div class="pw-form-messaging"><div class="pw-form-message-arrow"></div><p class="pw-form-text">' +
                            ACC.pwdHelpCheckText +
                            '</p><p class="status-message-8"><span class="icon icon-check"></span>' +
                            ACC.pwdHelpStatusText +
                            '</p><p class="status-message-char"><span class="icon icon-check"></span>' +
                            ACC.pwdHelpCharsText +
                            '</p></div>'
                    );
                $('[data-password-check]').addClass('mobile-pw-checker');
            }
        });

        $('#newPassword').focusout(function() {
            var $this = $(this),
                $parentNode = $this.parent();

            $parentNode.addClass('mobile-pw-checker-error');
        });

        $('#newPassword').keyup(function() {
            var passValue = $(this).val();

            if ($.trim(passValue).length > 7) {
                $('.status-message-8').addClass('tick-icon');
            } else {
                $('.status-message-8').removeClass('tick-icon');
                $('.status-message-char').removeClass('tick-icon');
            }

            var pwdProperty = $('#passwordRegex').text().trim();
            var passwordRegex = new RegExp(pwdProperty);

            if (passwordRegex.test(passValue)) {
                $('.status-message-char').addClass('tick-icon');
            } else {
                $('.status-message-char').removeClass('tick-icon');
            }

            var characterTick = $('p.status-message-8').hasClass('tick-icon'),
                letterNumber = $('p.status-message-char').hasClass('tick-icon'),
                $parentClass = $(this).closest('.form-group');

            if (characterTick === true && letterNumber === true) {
                if ($parentClass.find('i').length > 0) {
                    $parentClass.find('i').remove();
                }

                $(this)
                    .closest('.form-group')
                    .prepend('<i class="tick icon icon-check-circle"></i>');
                $parentClass.removeClass('has-error');
                $parentClass.find('div.help-block span').html('');
            } else {
                $parentClass.find('i').remove();
            }
        });
    },

    accountSelectBox: function() {
        $('#tjxUpdateProfileForm')
            .find('select')
            .each(function() {
                var $this = $(this);

                if ($this.val() !== null) {
                    $this.removeClass('inactive');
                }
            });

        $('#tjxUpdateProfileForm')
            .find('select')
            .on('change', function() {
                $(this).removeClass('inactive');
            });
    }
};

$(document).ready(function() {
    ACC.myaccount.bindAll();
});

window.addEventListener('beforeunload', function () {
    if ($('#gigya-my-account-treasure-notoptin').length) {
        window.scrollTo(0, 0);
    }
});